module.exports = __webpack_public_path__ + "img/trend-down-02.ca95a885.svg";